import React, {Component} from 'react';
// @ts-ignore
import Script from 'react-load-script';
const { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } = require('mdbreact');

declare global {
    interface Window {
        onAmazonLoginReady: ()=>void;
        onAmazonPaymentsReady: ()=>void;
        OffAmazonPayments: any;
        amazon:any;
    }
}

interface AmazonError {
    getErrorCode: ()=>string;
    getErrorMessage: ()=>string;
}
interface AmazonButtonProps {
    clickable:boolean;
    merchant: {
        amazonClientId?: string,
        amazonSellerId?: string,
        sandbox?:        string
    };
    updateAmazonStatus: (response: { amazonResponseProfile: any; orderId: string; status: string; }) => void;
    onAmazonError: (eCode: string, eMsg: string | undefined) =>void;
}

interface AmazonButtonState {
    showWallet:boolean;
    orderId:string|null;
    status:string|null;
    components:any;
    scriptLoaded?: boolean;

    amazonUserEmail?:string|null;
    amazonUserName?:string|null;
    amazonCustomerId?:string|null;
}

interface AmazonResponse {    
    orderId?: string; 
    status?: string; 
    profile?: { 
        PrimaryEmail: string | undefined; 
        Name: string | undefined; 
        CustomerId: string | undefined; 
    }; 
}

/**
 * renders the Amazon button for users to login to their Amazon account.
 * This component will call Amazon javascript on the page for initializing the login widget.
 */
class AmazonButton extends Component<AmazonButtonProps,AmazonButtonState> {
    constructor(props: AmazonButtonProps) {
        super(props);
        this.state = {
            showWallet: false,
            orderId: null,
            status: null,
            components: null
        }
    }

    showWallet = (value:boolean) => {
        this.setState({showWallet: value});
    }

    updateAmazonResponse = (response: AmazonResponse) => {
        if(response && response.orderId)
            this.setState({
                orderId : response.orderId
            })
        else if(response && response.status)
            this.setState({
                status : response.status
            })
        else if(response && response.profile){
            this.setState({
                amazonUserEmail: response.profile.PrimaryEmail ? response.profile.PrimaryEmail : null,
                amazonUserName: response.profile.Name ? response.profile.Name : null,
                amazonCustomerId: response.profile.CustomerId ? response.profile.CustomerId : null
            })
        }
    }
    
    saveWallet = () =>{
        this.setState({
            showWallet: false
        })
        this.props.updateAmazonStatus({
            orderId: this.state.orderId!,
            status: this.state.status!,
            amazonResponseProfile: {
                amazonUserEmail: this.state.amazonUserEmail,
                amazonUserName: this.state.amazonUserName,
                amazonCustomerId: this.state.amazonCustomerId
            }

        })
    }

    render() {
        let components = [];
        let timestamp =Date.now();

        //Amazon pay widget is created only during the first load of the external javascript. So in order for the button to not disappear
        //and load everytime it is mounted, the timestamp is added to the url. So the browser will reload thinking its a different url.
        let isSandbox = this.props.merchant.sandbox != null ? this.props.merchant.sandbox : true;
        const amazonWidgetUrl = isSandbox ? 'https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js'+'?timestamp='+timestamp
            :'https://static-na.payments-amazon.com/OffAmazonPayments/us/js/Widgets.js'+'?timestamp='+timestamp;
        components.push(
            <div key={'amazon-button'}
                 id="amazon-pay-button"
                 className={('amazon-pay-button')}>
            </div>);

        components.push(
                <MDBContainer key={'Wallet-Modal'}>
                    <MDBModal keyboard={true} backdrop={false}  isOpen={this.state.showWallet} toggle={this.showWallet}>
                        <MDBModalBody>
                            <div id={"wallet"} style={{"width": "450", "height":"500px"}}></div>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={()=>{this.showWallet(false)}}>Cancel</MDBBtn>
                            <MDBBtn color="primary" onClick={this.saveWallet}>Continue</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>)

        // use react-load-script to load 3rd party js library and call handleAmazonCreate to create the functions
        // that the library requires
        components.push(
            <Script key={'amazon-script'}
                     url={amazonWidgetUrl}
                     onCreate={() => {this.handleAmazonCreate(this.updateAmazonResponse)}}
                     onLoad={this.handleScriptLoad}
                     attributes={{async:'async'}}
        />);
        return components;
    }


    handleScriptLoad = () => {
        this.setState({
            scriptLoaded: true
        })
    }

    handleAmazonCreate = (updateAmazonResponse: (response: AmazonResponse) =>void) => {
        const {merchant, onAmazonError} = this.props;
        let isSandbox = merchant.sandbox != null ? merchant.sandbox : true;
        
        window.onAmazonLoginReady = () => {
            window.amazon.Login.setClientId(merchant.amazonClientId);
            window.amazon.Login.setSandboxMode(isSandbox);
        };

        window.onAmazonPaymentsReady = () => {
            // this call using amazon's library will inject the amazon button image into the 'amazon-pay-button' element
            window.OffAmazonPayments.Button('amazon-pay-button', merchant.amazonSellerId, {
                type: "PwA",
                color: "Gold",
                size: 'medium',
                authorization: () => {
                    let loginOptions = {
                        scope: "profile payments:widget",
                        popup: true
                    };
                    window.amazon.Login.authorize(loginOptions, (response: { error: any; })=> {
                        if ( response.error ) {
                            return;
                        }
                        window.amazon.Login.retrieveProfile( (response: { error: any; success: any; profile: any; }) => {
                            console.log('Amazon profile response: ', response)
                            if (response.error) {
                                return;
                            }
                            else if(response.success){
                                updateAmazonResponse({profile: response.profile || undefined})
                            }
                        });

                        this.showWallet(true);

                        new window.OffAmazonPayments.Widgets.Wallet({
                            sellerId: merchant.amazonSellerId,
                            onOrderReferenceCreate: (orderReference: { getAmazonOrderReferenceId: () => string; }) => {

                                // Use the following code to get the generated Order Reference ID.
                                let orderReferenceId = orderReference.getAmazonOrderReferenceId();
                                console.log("Reference Id", orderReferenceId);
                                updateAmazonResponse({orderId: orderReferenceId})
                            },
                            design: {
                                designMode: 'responsive'
                            },
                            onPaymentSelect: (orderReference:any) => {
                                // Replace this code with the action that you want to perform
                                // after the payment method is selected.

                                // Ideally this would enable the next action for the buyer
                                // such as a "Continue" or "Place Order" button.
                                updateAmazonResponse({status:"COMPLETED"});
                            },
                            onError: (error: AmazonError) => {
                                // Your error handling code.
                                // During development you can use the following
                                // code to view error messages:
                                console.log("Error during wallet process: ", error.getErrorCode() + ': ' + error.getErrorMessage());
                                onAmazonError(error.getErrorCode(), error.getErrorMessage());
                                // See "Handling Errors" for more information.
                            }
                        }).bind('wallet');
                    });
                },
                onError: (error:AmazonError) => {
                    //TODO: handle amazon pay error !!!
                    console.log("Amazon pay error", error);
                    onAmazonError(error.getErrorCode(), error.getErrorMessage());
                }
            });
        };
    }
}


export default AmazonButton;
